import axios from "axios";
import { API_URL } from "@/constants/env.const";

export const axiosInstance = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  timeout: 100_000,
  headers: { "X-Vetty-Fingerprint": String(Date.now()) },
});

export interface ApiResponse<TData = unknown, TMeta = unknown> {
  success: boolean;
  code: string;
  message: string;
  data?: TData;
  meta?: TMeta;
}

export const handleAxiosError = (error: unknown): ApiResponse | null => {
  if (axios.isAxiosError(error) && error.response?.data) {
    return error.response.data as ApiResponse;
  }
  return null;
};

/** API `code` from a failed response (e.g. `cannot_self_approve`). */
export const getApiErrorCode = (error: unknown): string | undefined => {
  const r = handleAxiosError(error);
  return typeof r?.code === "string" ? r.code : undefined;
};
